import React from 'react';
import classNames from 'classnames';
import { HyperdbListing } from '../../../../hyperdb';

export default HyperdbListing({
  collectionName: 'areas',
  namespace: 'area',
  mountedUrl: '/areas',
  title: 'Areas',
  columns: [
    { attribute: 'name' },
    { attribute: 'zone.name', label: 'zone' },
  ],
});



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/area/containers/Listing.jsx